
<template>
  <div  class="pm-embed-control" style="width:100%;height:100%;position:relative;">
    <div class="flex-wrap pd-embed-value"
      :class="{
        'pd-embed-empty-value':!value
      }"
    style="width:calc(100% - 32px);overflow:hidden;white-space:nowrap;text-overflow:ellipsis;font-size:12px;"  @click="modalSelector = true">
      {{value || '点击编辑'}}
    </div>
    <div class="flex-wrap flex-center" style="position:absolute;right:0;top:0;bottom:0;width:30px;color:#aaa;cursor:pointer" v-if="value" @click="$emit('input','')">
      <Icon type="md-trash" size="16" />
    </div>

    <Modal v-model="modalSelector" width="800" title="编辑文本" footer-hide>
      <div style="padding:10px">
        <Input type="textarea" :rows="10" v-model="value" @input="$emit('input',$event)" />
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {},
      modalSelector: false,
    };
  },
  props: ['value', 'editable'],
};
</script>

<style lang="scss" scoped>

</style>
